import Course1 from '../../../assets/images/courses/course_1.jpg';
import Course2 from '../../../assets/images/courses/course_2.jpg';
import Course3 from '../../../assets/images/courses/course_3.jpg';
import Course4 from '../../../assets/images/courses/course_4.jpg';
import Course5 from '../../../assets/images/courses/course_5.jpg';
import Course6 from '../../../assets/images/courses/course_6.jpg';
import Course7 from '../../../assets/images/courses/course_7.jpg';
import Course8 from '../../../assets/images/courses/course_8.jpg';
import Course9 from '../../../assets/images/courses/course_9.jpg';
import Course10 from '../../../assets/images/courses/course_10.jpg';
import Course11 from '../../../assets/images/courses/course_11.jpg';
import Course12 from '../../../assets/images/courses/course_12.jpg';
import Course13 from '../../../assets/images/courses/course_13.jpg';
import Course14 from '../../../assets/images/courses/course_14.jpg';
import Course15 from '../../../assets/images/courses/course_15.jpg';
import Course16 from '../../../assets/images/courses/course_16.jpg';
import FallbackImage from '../../../assets/images/Course1.jpg';

// Real learner photos, assigned per course id (stable regardless of list
// sort/filter order or whether the card is rendered on the Home slider, the
// Courses grid, or the course detail page).
const COURSE_IMAGE_BY_ID = {
  30: Course1,
  28: Course2,
  27: Course3,
  26: Course4,
  25: Course5,
  24: Course6,
  14: Course7,
  13: Course8,
  12: Course9,
  11: Course10,
  10: Course11,
  9: Course12,
  6: Course13,
  5: Course14,
  4: Course15,
  3: Course16,
};

// A few of the above are portrait photos with the learner's face high in the
// frame, so the card's wide, short crop box (object-fit: cover, default
// center) was cutting through their faces. Bias those crops toward the top.
const COURSE_IMAGE_POSITION_BY_ID = {
  25: 'center 20%', // Course5 - face cut off, bias top
  24: 'center 13%', // Course6 - face cut off, bias top
  13: 'center 3%', // Course8 - hair touches the very top edge of the source photo
  12: 'center 22%', // Course9
  10: 'center 20%', // Course11
  9: 'center 12%', // Course12
  6: 'center 24%', // Course13
  5: 'center 12%', // Course14
  4: 'center 22%', // Course15
  3: 'center 18%', // Course16
};

// Course10.jpg (id 11) is a two-person portrait shot with the second person's
// face near the top-right, under the card's duration badge. A plain
// object-position can't shift it horizontally because object-fit: cover
// already maps the full image width 1:1 onto the (wider) card box, leaving no
// horizontal slack to pan. Explicitly oversizing + repositioning the image
// (the <img> equivalent of background-size/background-position beyond
// "cover") creates that slack, so the crop can include both faces while
// keeping the badge (left untouched, per instruction) clear of the second
// person's face. Tuned for the course card / detail-summary aspect ratio (37/19).
const COURSE_IMAGE_CROP_BY_ID = {
  11: {
    position: 'absolute',
    width: '180%',
    maxWidth: 'none',
    height: '467.5%',
    left: '-80%',
    top: '-22.04%',
    objectFit: 'fill',
  }, // Course10
};

export function getCourseImageSrc(course, apiImageUrl) {
  const mapped = COURSE_IMAGE_BY_ID[course?.id];
  if (mapped) return mapped;
  if (course?.image) return `${apiImageUrl}${course.image}`;
  return FallbackImage;
}

export function getCourseImageObjectPosition(course) {
  return COURSE_IMAGE_POSITION_BY_ID[course?.id] || 'center';
}

export function getCourseImageCropStyle(course) {
  return COURSE_IMAGE_CROP_BY_ID[course?.id] || null;
}

export { FallbackImage };
